import { render, staticRenderFns } from "./CodeOfConductModal.vue?vue&type=template&id=2d1e6e3d&"
import script from "./CodeOfConductModal.vue?vue&type=script&lang=js&"
export * from "./CodeOfConductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCheckbox,VCol,VDialog,VIcon,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src108905794/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1e6e3d')) {
      api.createRecord('2d1e6e3d', component.options)
    } else {
      api.reload('2d1e6e3d', component.options)
    }
    module.hot.accept("./CodeOfConductModal.vue?vue&type=template&id=2d1e6e3d&", function () {
      api.rerender('2d1e6e3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CodeOfConductModal.vue"
export default component.exports